import { Directive, HostListener, Input } from '@angular/core';
import {
  FormGroup,
  NG_VALIDATORS,
  Validator,
  ValidationErrors,
} from '@angular/forms';
import { EmailValidatorService } from '../validators/email.validator';

@Directive({
  selector: '[appInputBlurDirective]',
  standalone: true,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: InputBlurDirective,
      multi: true,
    },
  ],
})
export class InputBlurDirective implements Validator {
  @Input('appInputBlurDirective') formGroup!: FormGroup;

  constructor(private emailValidator: EmailValidatorService) {}

  @HostListener('blur', ['$event.target'])
  onBlur(target: HTMLInputElement) {
    const name = this.formGroup?.get('name');
    const lastName = this.formGroup?.get('lastName');
    const email = this.formGroup?.get('email');
    if (!name.valid || !lastName.valid || !email.valid) return;
    email.setAsyncValidators(this.emailValidator.checkEmail());
    email.updateValueAndValidity();
  }

  @HostListener('focus', ['$event.target'])
  onFocus(target: HTMLInputElement) {
    if (
      target.id === 'inputFirstName' ||
      target.id === 'inputLastName' ||
      target.id === 'inputEmail'
    ) {
      const email = this.formGroup?.get('email');
      if (email) {
        email.setAsyncValidators(null);
        email.updateValueAndValidity({ emitEvent: false });
      }
    }
  }

  validate(): ValidationErrors | null {
    return null;
  }
}
